<template>
  <section>
    <PageTitle title="All Bayked Exclusive Deals" v-if="!hidePageTitle"
               v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/bayked_exclusive_deals',title:'Bayked Exclusive Deals'}]"
    />
    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox-title">
            <h5 class="pull-left">
              All Marketplace Exclusive Deals
            </h5>
            <a v-on:click="addUpdateDeal(true)"
               class="pull-right"
            >Add New Deal
            </a>
          </div>

          <div class="ibox-content">
            <div class="row">
              <div class="col-md-3">
                <label>
                  Restaurant
                </label>
                <multiselect
                    v-model="selectedRestaurant"
                    :options="allRestaurants"
                    label="name"
                    track-by="name"
                    @close="bindSelectedRestaurantToFetchBranches()"/>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>
                    Branch
                    <b v-if="selectedRestaurant === ''"
                       class="text-danger text-sm"
                    >
                      (select Restaurant)
                    </b>
                  </label>

                  <select v-model="selectedBranch"
                          class="form-control styleSelectElement"
                          :disabled="(selectedRestaurant === '')">
                    <option value=""
                    >
                      Select Branch
                    </option>
                    <option v-for="branch in allBranches"
                            :value="branch.id"
                    >
                      {{branch.areasByAreaId.name}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label>
                    Forever Deals
                  </label>

                  <select v-model="foreverDeal"
                          class="form-control styleSelectElement">
                    <option value=""
                    >
                      Select Deals Type
                    </option>
                    <option :value="true"
                    >
                      TRUE
                    </option>
                    <option :value="false"
                    >
                      FALSE
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label>
                    Disabled Deals
                  </label>

                  <select v-model="isDealDisable"
                          class="form-control styleSelectElement">
                    <option value=""
                    >
                      Select Deals Status
                    </option>
                    <option :value="true"
                    >
                      TRUE
                    </option>
                    <option :value="false"
                    >
                      FALSE
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-3">
                <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-primary btn-sm search_filter_btn"><i class="fa fa-search"></i> Search</button>
                <button style="margin-top: 25px" class=" btn btn-info btn-sm refresh_filter_btn"><i class="fa fa-refresh"></i> Refresh</button>
              </div>
            </div>
            <br/>
            <div class="row">
              <div class="ibox">
                <div class="ibox-content">
                  <div class="table-responsive">
                    <table class="table table-striped table-responsive table-bordered table-hover"
                           id="BaykedExclusiveDeals">
                      <thead>
                      <tr>
                        <th>Deal id</th>
                        <th>Restaurant Name </th>
                        <th>Branch Name</th>
                        <th>Item Name</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Savings</th>
                        <th>Active</th>
                        <th>Forever Deals</th>
                        <th class="text-center"><i class="fa fa-bolt action_btn"></i></th>
                      </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddUpdateBaykedExclusiveDeal ref="addUpdateBaykedExclusiveDealPopUp" />
  </section>
</template>

<script>
import PageTitle from "../components/layout_components/PageTitle";
import Multiselect from "vue-multiselect";
import {getAllBranchesOfRestaurant, getAllRestaurant} from "../api/restaurants";
import state from "../store";
import AddUpdateBaykedExclusiveDeal from "../components/restaurants/AddUpdateBaykedExclusiveDeal";

export default {
  name: "BaykedExclusiveDeals",
  components: {
    AddUpdateBaykedExclusiveDeal,
    PageTitle,
    Multiselect},
  data(){
    return {
      allRestaurants: [],
      allBranches: [],
      selectedRestaurant: '',
      selectedBranch: '',
      baykedExclusiveDeals: [],
      dataTable: null,
      foreverDeal: '',
      isDealDisable: ''
    }
  },
  props: {
    hidePageTitle: {
      type: Boolean,
      default: false,
    }
  },
  async mounted() {
    await this.fetchAllRestaurants();
    await this.jQueryOnRefreshButton();
    await this.jQueryOnSearchButton();
    await this.initializeDatatable();
  },
  methods: {
    fetchAllRestaurants: async function () {
      let allRestaurantResp = await getAllRestaurant();
      this.allRestaurants = allRestaurantResp.data;
    },
    resetDatatableColumns: function (){
      this.dataTable.column(1).search('');
      this.dataTable.column(2).search('');
      this.dataTable.column(7).search('');
      this.dataTable.column(8).search('');
    },
    jQueryOnRefreshButton(){
      let self= this;
      $(".refresh_filter_btn").click( function () {
        self.resetDatatableColumns();
        self.selectedBranch = '';
        self.selectedRestaurant = '';
        self.foreverDeal='';
        self.isDealDisable ='';
        self.dataTable.draw();
      });
    },
    jQueryOnSearchButton: function (){
      let self= this;
      $(".search_filter_btn").click( function () {
        self.resetDatatableColumns();
        if(self.selectedRestaurant !== null){
          self.dataTable.column(1).search(self.selectedRestaurant.id);
        }if(self.selectedBranch !== null){
          self.dataTable.column(2).search(self.selectedBranch);
        }if(self.isDealDisable !== ''){
          self.dataTable.column(6).search(self.isDealDisable)
        }if(self.foreverDeal !== ''){
          self.dataTable.column(7).search(self.foreverDeal)
        }
        self.dataTable.draw();
      });
    },
    bindSelectedRestaurantToFetchBranches: async function () {
      if(this.selectedRestaurant !== '') {
        let params = new URLSearchParams();
        params.append("restaurant_id", this.selectedRestaurant.id);
        let restaurantAllBranch = await getAllBranchesOfRestaurant(params);
        this.allBranches = restaurantAllBranch.data;
      }
    },
    initializeDatatable: function(){
      let self = this;
      let processingURL = state.getters.mainAppURL + "bayked_exclusive_deals/get_all_bayked_exclusive_deals";
      self.dataTable = $('#BaykedExclusiveDeals').DataTable({
        "processing": true,
        "serverSide": true,
        "pagingType": "simple",
        "dom":'ltipr',
        "lengthMenu": [10, 25, 50, 100, 250],
        autoWidth: false,
        "order": [[0, "desc"]],
        'language': {
          'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
              '                <div class="sk-double-bounce1"></div>\n' +
              '                <div class="sk-double-bounce2"></div>\n' +
              '              </div>'
        },
        "ajax": {
          url: processingURL,
          type: "post",
          data: function ( d ) {
            return JSON.stringify( d );
          },
          headers: {
            "Content-type": "application/json; charset=utf-8"
          },
          beforeSend:  (xhr) => {
            xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
          },
          statusCode: {
            401: () => {
              this.updateRefreshTokenInDataTable(this.dataTable);
            }
          }
        },
        "columnDefs": [
          {
            "orderable": false, "targets": [1, 2, 3, 4, 5, 6, 7, 8, 9]
          },
          {
            'className': "text-center", 'aTargets': [0, 1, 2, 3, 4, 5, 7, 8]
          },
          {
            "targets": [ 2, 3, 4, 5 ], "searchable": false
          }
        ],
        "columns": [
          {
            "data": "id",
            "name": "id",
          },
          {
            "data": "restaurantName",
            "name": "restaurantName",
          },
          { "data": "branchName",
            "name":"branchName"
          },
          { "data": "menuItemName",
            "name":"menuItemName"
          },
          { "data": "startDate",
            "name": "startDate",
            "render": function(data){
              return (data === null) ? "N/A" : "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
            }
          },
          { "data": "endDate",
            "name": "endDate",
            "render": function(data){
              return (data === null) ? "N/A" : "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
            }
          },
          { "data": "menuItemsByMenuItemId",
            "name": "menuItemsByMenuItemId",
            "render": function(data){
              return (data.menuItemTypesById && data.menuItemTypesById.length > 0) ? data.menuItemTypesById.map((e, index)=>`<b> ${index+1}.  </b>${e.savingCost} Rs`) :  "N/A"
            }
          },
          {
            "data": "deleted",
            "name": "deleted",
            "render": function (data) {
              let label = "";
              label = (data) ? "danger" : "success";
              return "<label class='label label-" + label + "'>" + ((data) ? 'No' : 'Yes') + "</label>";
            }
          },
          {
            "data": "foreverDeal",
            "name": "foreverDeal",
            "render": function (data) {
              let label = "";
              label = (data) ? "success" : "danger";
              return "<label class='label label-" + label + "'>" + ((data) ? 'Yes' : 'No') + "</label>";
            }
          },
          {
            "data": "actions", "name":"actions",
            "render": function(data, type, row){
              return '<a class="editMenuItem" data-id="'+ row.id+'">Edit</a>';
            }
          }
        ],
        "drawCallback": function( settings ) {
          $('.editMenuItem').click(function (){
            let item_id = $(this).attr("data-id");
            self.addUpdateDeal(false, item_id);
          });
        },
        "tableTools": {
          "sSwfPath": "js/plugins/dataTables/swf/copy_csv_xls_pdf.swf"
        }
      });
      $.fn.dataTable.ext.errMode = 'none';
    },
    addUpdateDeal: function (isNewDeal, baykedDeal=null) {
      this.$refs.addUpdateBaykedExclusiveDealPopUp.load(isNewDeal, baykedDeal);
    },
  }
}
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"/>
<style scoped>
.styleSelectElement {
  height: 40px;
}
</style>